import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { maintenanceService, propertyService } from "../configs/constants";

interface Option {
  label: string;
  value: string;
  default?: boolean | Object;
}

interface FilterItem {
  name: string;
  label: string;
  options: Option[];
  search: boolean;
  unitLoading?: boolean;
  initialValue?: string;
}

interface UseFilterOptionsParams {
  filterStatus: Option[];
}

const getPropertyService = `${propertyService}/property/propertyList`;
const getUnitService = `${maintenanceService}/unit/unitList?perPage=20000`;
export const useFilterOptions = ({ filterStatus }: UseFilterOptionsParams) => {
  const [filterOptions, setFilterOptions] = useState<FilterItem[]>([
    {
      name: "property",
      label: "Property",
      options: [],
      search: true,
      initialValue: "",
    },
    {
      name: "unit",
      label: "Unit",
      options: [],
      search: true,
      unitLoading: false,
      initialValue: "",
    },
    // {
    //   name: "status",
    //   label: "Status",
    //   options: filterStatus || [],
    //   search: true,
    //   initialValue: "all",
    // },
  ]);

  const [selectedPropertyId, setSelectedPropertyId] = useState<string | null>(null);
  const [selectedUnitId, setSelectedUnitId] = useState<string | null>(null);
  // Fetch properties
  const fetchProperties = useCallback(async () => {
    try {
      const { data } = await axios.get(getPropertyService);

      const propertyList = [
        { label: "All", value: "" },
        ...(data?.result?.map((item: any) => ({
          value: item.propertyId,
          label: item.buildingName, // + " : " + item.buildingCode
          title: "property",
          key: item.buildingName,
        })) || []),
      ];

      setFilterOptions((prev) =>
        prev.map((item) => (item.name === "property" ? { ...item, options: propertyList } : item))
      );
    } catch (error) {
      console.error("Failed to fetch properties:", error);
    }
  }, []);

  const fetchUnits = useCallback(async (propertyId?: string) => {
    setFilterOptions((prev) => prev.map((item) => (item.name === "unit" ? { ...item, unitLoading: true } : item)));

    try {
      const url = propertyId ? `${getUnitService}/?&propertyId=${propertyId}` : getUnitService;

      const { data } = await axios.get(url);

      const unitList = [
        { label: "All", value: "" },
        ...(data?.result?.data?.map((u: any) => ({
          label: u?.unit?.unitCode,
          value: u?.unitId,
          key: u?.unitId,
          title: "unit",
        })) || []),
      ];

      setFilterOptions((prev) =>
        prev.map((item) => (item.name === "unit" ? { ...item, options: unitList, unitLoading: false } : item))
      );
    } catch (error) {
      console.error("Failed to fetch units:", error);
      setFilterOptions((prev) => prev.map((item) => (item.name === "unit" ? { ...item, unitLoading: false } : item)));
    }
  }, []);

  // Initial property fetch
  useEffect(() => {
    fetchProperties();
  }, [fetchProperties]);

  // Refetch units when property changes
  useEffect(() => {
    // fetchUnits(selectedPropertyId);
    fetchUnits();
  }, [fetchUnits]);

  return {
    filterOptions,
    setSelectedPropertyId,
    reloadProperties: fetchProperties,
    reloadUnits: fetchUnits,
    setSelectedUnitId,
    selectedUnitId,
    selectedPropertyId,
  };
};
